import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '@/contexts/LanguageContext';
import { analytics } from '@/lib/analytics';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import {
  LayoutDashboard,
  Heart,
  Globe,
  Users,
  Calendar,
  Cpu,
  BarChart3,
  Rocket,
} from 'lucide-react';

const pages = [
  { href: '/dashboard', labelKey: 'nav.overview', icon: LayoutDashboard },
  { href: '/mental-health-dimension', labelKey: 'nav.mentalHealth', icon: Heart },
  { href: '/regional-analysis', labelKey: 'nav.regionalAnalysis', icon: Globe },
  { href: '/member-insights', labelKey: 'nav.memberInsights', icon: Users },
  { href: '/programs-events', labelKey: 'nav.programsEvents', icon: Calendar },
  { href: '/technology-future', labelKey: 'nav.technologyFuture', icon: Cpu },
  { href: '/impact-metrics', labelKey: 'nav.impactMetrics', icon: BarChart3 },
  { href: '/vision-2040', labelKey: 'nav.vision2040', icon: Rocket },
];

export function CommandPalette() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  const handleSelect = (href: string) => {
    // Track command palette navigation
    analytics.navigation(location.pathname, href, 'command_palette');
    setOpen(false);
    navigate(href);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder={t('ui.commandPalette.searchPlaceholder')} />
      <CommandList>
        <CommandEmpty>{t('ui.commandPalette.noResults')}</CommandEmpty>
        <CommandGroup heading={t('ui.commandPalette.pagesHeading')}>
          {pages.map((page) => {
            const Icon = page.icon;
            return (
              <CommandItem
                key={page.href}
                value={t(page.labelKey)}
                onSelect={() => handleSelect(page.href)}
                className="cursor-pointer"
              >
                <Icon className="mr-2 h-4 w-4 text-muted-foreground" />
                <span>{t(page.labelKey)}</span>
              </CommandItem>
            );
          })}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
